import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import BasePanel from './BasePanel';

const CardSkeletonScreen = () => (
    <BasePanel>
        <div className="display-flex align-items-center margin-top-20">
            <div style={{ minWidth: '160px' }}>
                <ContentLoader height={14} width={120} />
            </div>
            <div className="flex-1-0">
                <ContentLoader height={8} width={'100%'} />
            </div>
            <ContentLoader height={14} width={40} className="margin-left-10" />
        </div>
    </BasePanel>
);

export default CardSkeletonScreen;
